import { render, staticRenderFns } from "./SellerMenu.vue?vue&type=template&id=cc7adf76&"
import script from "./SellerMenu.vue?vue&type=script&lang=ts&"
export * from "./SellerMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports